<div
  *ngIf="subProject.installByInpress && !!invoice"
  class="sticker-facturation-container"
>
  <div
    *ngIf="displayCompanyName && invoice.company?.regularName?.length > 0"
    class="subtitle font-weight-bold"
  >
    {{ invoice.company.regularName }}
  </div>
  <table
    class="facturation-overview-table"
    [class.upper-space]="displayCompanyName"
  >
    <tr class="header-row">
      <th class="id">Jobnr</th>
      <th class="date">Aanvraag</th>
      <th class="description">Omschrijving</th>
      <th class="price">
        <div class="d-flex justify-content-end">
          <span>Prijs</span>
        </div>
      </th>
    </tr>
    <tr>
      <td class="id accent">
        <span>{{ projectId | or }}</span>
      </td>
      <td class="date">
        <span>{{ subProject.currentCreatedAt | date : 'dd.MM.yyyy' }}</span>
      </td>
      <ng-container *ngIf="subProject.signSticker != null; else otherSticker">
        <td class="description accent">
          Sticker: {{ subProject.signSticker?.text }}
        </td>
        <td class="price">
          <ng-container
            *ngIf="
              !invoice.onlyChargePriceLines &&
              subProject.signSticker?.charge?.value &&
              subProject.signSticker?.charge?.price > 0
            "
          >
            {{
              (subProject.signSticker.charge.price *
                charge *
                (secondBoardPresent ? 2 : 1)) /
                numInvolvedCompanies | asFormatDecimal : true : 2
            }}
            €
          </ng-container>
        </td>
      </ng-container>
      <ng-template #otherSticker>
        <td class="description accent">
          Sticker: {{ subProject.otherSticker }}
        </td>
        <td class="price">
          <ng-container *ngIf="!invoice.onlyChargePriceLines">
            {{
              (10 * charge * (secondBoardPresent ? 2 : 1)) /
                numInvolvedCompanies | asFormatDecimal : true : 2
            }}
            €
          </ng-container>
        </td>
      </ng-template>
    </tr>
    <tr *ngIf="!invoice.onlyChargePriceLines">
      <td class="id accent"></td>
      <td class="date"></td>
      <td class="description">+ Aanbrengen sticker</td>
      <td class="price">
        {{ 20 / numInvolvedCompanies | asFormatDecimal : true : 2 }} €
      </td>
    </tr>
    <ng-container *ngIf="invoice.priceLines?.length > 0">
      <ng-container *ngFor="let priceLine of invoice.priceLines">
        <tr *ngIf="priceLine?.price > 0">
          <td class="id accent"></td>
          <td class="date"></td>
          <td class="description">
            {{ priceLine.text }}
          </td>
          <td class="price">
            {{ priceLine.price | asFormatDecimal : true : 2 }} €
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </table>
</div>
